import { CheckCheck, HandPlatter, ScanLine } from "lucide-react";
import { useState } from "react";

import CartaoGarcom from "./CartaoGarcom";
import { CartoesKdsCarregando } from "./ColunaKds";
import LerQrSaida from "../../mesa-saida/LerQrSaida";
import { useSaidaQrLigada } from "../../mesa-qr/useMesaQrLigado";
import { montarGarcom, pratosParaLevar } from "../lib/garcom";

const COLUNAS = [
  { chave: "paraLevar", label: "Para levar", icone: HandPlatter, cor: "bg-emerald-600", fundo: "bg-emerald-50 dark:bg-emerald-950/30", vazio: "Nada pra levar agora" },
  { chave: "entregues", label: "Entregues", icone: CheckCheck, cor: "bg-zinc-600", fundo: "bg-zinc-100 dark:bg-zinc-900/40", vazio: "Nenhuma entrega ainda" },
];

/** Tela do Garçom: pratos de mesa (PDV e Mesa QR) que saíram da cozinha.
 *
 *  Mesmo desenho da cozinha — duas colunas no computador, uma aba por vez no
 *  celular — porque o garçom normalmente está com o celular ou um tablet na
 *  mão. "Entregues" existe pra desfazer um toque errado; some junto com o
 *  pedido quando a mesa fecha.
 */
export default function ModoGarcom({ pedidos, desktop, products, onEntregar, onEntregarTudo, vista = "todos", folga, carregando = false }) {
  const [aba, setAba] = useState("paraLevar");
  const [lendoSaida, setLendoSaida] = useState(false);
  const qrLigado = useSaidaQrLigada();
  const listas = montarGarcom(pedidos);
  const esperando = pratosParaLevar(listas.paraLevar);
  // Computador: as duas colunas ou só a escolhida no topo (tela única).
  // Celular: uma aba por vez, como sempre.
  const visiveis = desktop
    ? (vista === "todos" ? COLUNAS : COLUNAS.filter((c) => c.chave === vista))
    : COLUNAS.filter((c) => c.chave === aba);

  return (
    <div className="flex-1 min-h-0 flex flex-col">
      {!desktop && (
        <div className="px-3 pt-2 grid grid-cols-2 gap-2">
          {COLUNAS.map((c) => {
            const ativa = aba === c.chave;
            const n = c.chave === "paraLevar" ? esperando : listas.entregues.length;
            return (
              <button key={c.chave} onClick={() => setAba(c.chave)}
                className={`h-11 rounded-xl text-sm font-bold flex items-center justify-center gap-2 transition-colors ${ativa ? `${c.cor} text-white` : "bg-muted text-muted-foreground"}`}>
                {c.label}
                {!carregando && <span className={`inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 rounded-full text-xs font-bold ${ativa ? "bg-white/25" : `${c.cor} text-white`}`}>{n}</span>}
              </button>
            );
          })}
        </div>
      )}

      <div className={`flex-1 min-h-0 p-2 sm:p-3 lg:p-4 flex ${desktop ? "flex-row gap-4" : "flex-col"}`}>
        {visiveis.map((col) => {
          const lista = listas[col.chave];
          const Icone = col.icone;
          const n = col.chave === "paraLevar" ? esperando : lista.length;
          return (
            <section key={col.chave} className="flex-1 min-w-0 flex flex-col min-h-0">
              {desktop && (
                <div className={`${col.cor} text-white px-4 py-2 rounded-t-xl flex items-center justify-between flex-shrink-0`}>
                  <span className="font-bold text-sm">{col.label}</span>
                  {!carregando && <span className="bg-white/20 text-xs font-bold px-2.5 py-0.5 rounded-full">{n}</span>}
                </div>
              )}
              <div className={`${col.fundo} border ${desktop ? "rounded-b-xl border-t-0" : "rounded-xl"} flex-1 min-h-0 overflow-y-auto p-2 sm:p-3 ${folga ? "!pb-28" : qrLigado ? "pb-20" : ""}`}>
                {carregando ? <CartoesKdsCarregando desktop={desktop} quantos={2} /> : lista.length === 0 ? (
                  <div className="h-full flex flex-col items-center justify-center text-muted-foreground gap-2">
                    <Icone className="w-8 h-8 opacity-30" />
                    <span className="text-sm">{col.vazio}</span>
                  </div>
                ) : (
                  <div className={desktop ? "kds-grid" : "flex flex-col gap-3"}>
                    {lista.map((card) => (
                      <CartaoGarcom key={card._cardId} card={card} entregues={col.chave === "entregues"}
                        onEntregar={onEntregar} onEntregarTudo={onEntregarTudo} products={products} mobile={!desktop} />
                    ))}
                  </div>
                )}
              </div>
            </section>
          );
        })}
      </div>
      {/* Mesa QR: o garçom confere o comprovante do cliente e libera a saída */}
      {qrLigado && <button type="button" onClick={() => setLendoSaida(true)} data-e2e="garcom-ler-saida"
        className="fixed right-4 bottom-[calc(1rem+env(safe-area-inset-bottom,0px))] z-40 h-12 px-4 rounded-full bg-primary text-primary-foreground shadow-lg font-bold text-sm flex items-center gap-2">
        <ScanLine className="w-5 h-5" /> Ler QR de saída
      </button>}
      <LerQrSaida aberto={lendoSaida} onFechar={() => setLendoSaida(false)} />
    </div>
  );
}
